<template>
  <div v-if="bankPayHtml" v-html="bankPayHtml"></div>
  <div v-else>
    <headPage></headPage>
    <div style="border-bottom: 1px solid #eee; margin-bottom: 10px"></div>
    <div class="left_title">
      <span @click="gobidbond">保函列表</span> > 保函详情
    </div>
    <div style="padding: 20px 0; width: 600px; margin: 0 auto">
      <el-steps :active="isPage">
        <el-step title="填写申请信息" description=""></el-step>
        <el-step title="付款" description=""></el-step>
        <el-step title="开立保函" description=""></el-step>
      </el-steps>
    </div>
    <div class="applyFor" v-loading="dataLoading">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          padding: 10px 0;
        "
      >
        <i
          style="font-size: 26px; margin-right: 10px"
          class="el-icon-document"
        ></i>
        <div v-if="formModel.status == '03' || formModel.status == '06'">
          保函已开立，请下载
        </div>
        <div v-else>保函开立中，请耐心等待</div>
      </div>
      <el-form
        style="background: #fff"
        ref="form"
        size="small"
        :model="formModel"
        class="demo-ruleForm"
      >
        <div
          style="
            line-height: 40px;
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
            font-weight: 700;
          "
        >
          支付信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="订单状态：">
              <span class="el_item_text" style="padding-right: 20px">{{
                formModel.statusName
              }}</span>
              <el-button
                v-if="formModel.status == '03'"
                size="mini"
                type="primary"
                @click="goInvoiceAdmin"
                >去开票</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款金额：">
              <span class="el_item_text"
                >{{ formModel.guaranteePayMoney }} 元</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单提交时间：">
              <span class="el_item_text">{{ formModel.created }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="支付方式：">
              <span class="el_item_text">扫码支付</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          style="
            border-bottom: 1px solid #eee;
            font-weight: 700;
            margin-bottom: 10px;
            padding: 10px 0;
          "
        >
          投标企业信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业名称：">
              {{ companyInfo.etpName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社会信用代码：">
              {{ companyInfo.etpUscc }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注册资本：">
              {{ companyInfo.etpRegCapital }} 元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业：">
              {{ companyInfo.etpIndustryName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业性质：">
              {{ companyInfo.etpPropertyName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册地址：">
              {{ companyInfo.etpAddrFullName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件签发日期：">
              {{
                companyInfo.etpCertBeginDate +
                ' 至 ' +
                companyInfo.etpCertEndDate
              }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="营业执照：">
              <upLoadImg v-model="companyInfo.etpIdcard" :limit="upload.limit" :viewImage="upload.viewImage">
              </upLoadImg>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="上年度资产规模：">
              {{ formModel.etpLastAssets }} 万元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上年度营业收入：">
              {{ formModel.etpLastIncome }} 万元
            </el-form-item>
          </el-col>
          <el-col :span="24" style="margin-top: -20px">
            <div style="display: flex; align-items: center">
              <span style="padding-top: 25px">营业执照：</span>
              <upLoadImg
                v-model="companyInfo.etpIdcard"
                :limit="upload.limit"
                :viewImage="upload.viewImage"
              >
              </upLoadImg>
            </div>
          </el-col>
        </el-row>
        <div
          style="
            border-bottom: 1px solid #eee;
            font-weight: 700;
            margin-bottom: 10px;
            padding: 10px 0;
          "
        >
          项目信息
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称：">
              <span class="el_item_text">{{ formModel.projectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目编号：">
              <span class="el_item_text">{{ formModel.projectCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招标单位：">
              <span class="el_item_text">{{ formModel.bidCompanyName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招标截止日期：">
              <span class="el_item_text">{{ formModel.bidEndDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="担保金额（人民币）：">
              <span class="el_item_text">{{ formModel.guaranteeMoney }}元</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函有效期：">
              <span class="el_item_text">{{
                formModel.guaranteeBeginDate +
                ' 至 ' +
                formModel.guaranteeBeginDate
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函邮寄地址：">
              {{ formModel.guaranteePostAddrFullName }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
          <el-form-item label="保函文本">
            <i style="font-size: 30px;" class="el-icon-document"></i>
          </el-form-item>
        </el-col> -->
          <el-col :span="12">
            <div style="display: flex; align-items: center; margin-top: -25px">
              <span style="padding-top: 25px"
                >招标方发布的招标（采购）文件：</span
              >
              <upLoadImg
                v-model="companyInfo.bidDocument"
                :limit="upload.limit"
                :viewImage="upload.viewImage"
              >
              </upLoadImg>
            </div>
          </el-col>
          <el-col
            :span="12"
            v-if="formModel.status == '03' || formModel.status == '06'"
          >
            <el-form-item label="已开立保函（点击下载）：">
              <i
                style="font-size: 30px"
                class="el-icon-document"
                @click="downClick"
              ></i>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="我要给客服留言：">
              <span class="el_item_text">{{ formModel.remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center; padding: 20px 0">
        <el-button
          style="width: 500px; height: 40px; font-size: 20px"
          type="primary"
          @click="goBackList"
          >返回保函列表</el-button
        >
      </div>
      <el-dialog :visible.sync="dialogVisible" width="40%">
        <div v-html="payData"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import headPage from '@/components/head/index.vue'
import { getDetailZtb, getZtbPay } from '@/api/adminData/index'
import { parseTime } from '@/utils/DateUtils'
import upLoadImg from '@/components/uploadImg/index.vue'
import { downloadFile } from '@/api/user/file'
export default {
  components: { upLoadImg, headPage },
  data() {
    return {
      dataLoading: false,
      bankPayHtml: '',
      companyInfo: {},
      upload: {
        limit: 1,
        viewImage: true
      },
      isPage: 2, // 0填写申请信息 1付款信息  2开立保函
      timer: null, // 定时器
      dialogVisible: false,
      radio: 0,
      formModel: {}, // 项目信息
      guaranteeId: '',
      etpRA: {},
      payData: null,
      payType: '00', // 支付方式 00:二维码支付;01:企业网银在线支付
      isPaybtn: 1
    }
  },
  mounted() {
    this.isPage = this.$route.query.type ? Number(this.$route.query.type) : 0
    this.isPaybtn = this.$route.query.isPaybtn || 1
    this.guaranteeId = this.$route.query.guaranteeId
    this.getDetailData()
  },
  methods: {
    gobidbond() {
      this.$router.push({
        path: '/bidBondAdmin'
      })
    },
    goInvoiceAdmin() {
      this.$router.push({
        path: '/invoiceAdmin'
      })
    },
    downClick() {
      // downloadFile({ guid: this.formModel.returnGuarantee }).then((res) => {
      //   let url = window.URL.createObjectURL(new Blob([res.data]))
      //   let link = document.createElement('a')
      //   link.style.display = 'none'
      //   link.href = url
      //   link.setAttribute('download', '投标保涵') // 自定义下载文件名（如exemple.txt）
      //   document.body.appendChild(link)
      //   link.click()
      // })
      downloadFile({ guid: this.formModel.returnGuarantee }).then((res) => {
        this.loading = false
        console.log('压缩包打印数据')
        // console.log(res)
        const content = res.data
        const blob = new Blob([content], { type: 'application/pdf' })
        const fileName = this.formModel.guaranteeCategoryName
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      })
    },
    goPay() {
      // 支付
      if (this.radio == 0) {
        // 二维码
        getZtbPay({
          guaranteeId: this.guaranteeId,
          payType: this.payType
        }).then((res) => {
          if (res.success) {
            this.payData = res.result
            this.dialogVisible = true
          } else {
            this.$message.error(res.message)
          }
          this.contentLoading = false
        })
      } else {
        // 银行卡
        getZtbPay({
          guaranteeId: this.guaranteeId,
          payType: '01'
        }).then((res) => {
          if (res.success) {
            this.bankPayHtml = res.result
          } else {
            this.$message.error(res.message)
          }
          this.contentLoading = false
        })
      }
    },
    getDetailData() {
      // 获取详情
      this.dataLoading = true
      getDetailZtb({ guaranteeId: this.guaranteeId }).then((res) => {
        this.dataLoading = false
        if (res.success) {
          // 企业信息
          this.companyInfo = res.result
          this.companyInfo.etpCertBeginDate = parseTime(
            this.companyInfo.etpCertBeginDate,
            '{y}-{m}-{d}'
          )
          this.companyInfo.etpCertEndDate = parseTime(
            this.companyInfo.etpCertEndDate,
            '{y}-{m}-{d}'
          )
          this.formModel = res.result
          this.formModel.bidEndDate = parseTime(this.formModel.bidEndDate)
          this.formModel.guaranteeBeginDate = parseTime(
            this.formModel.guaranteeBeginDate,
            '{y}-{m}-{d}'
          )
          this.formModel.guaranteeEndDate = parseTime(
            this.formModel.guaranteeEndDate,
            '{y}-{m}-{d}'
          )
          this.formModel.created = parseTime(
            this.formModel.created,
            '{y}-{m}-{d}'
          )
        } else {
          this.$message.error(res.message)
        }
        this.contentLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.applyFor {
  width: 1200px;
  margin: 0 auto;
}

::v-deep .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 0 0;
}

.el_item_text {
  color: #000;
}

.red {
  color: #f00 !important;
}

::v-deep .el-dialog__body {
  padding: 0 0;
}

::v-deep .el-dialog__header {
  padding: 0;
  padding-bottom: 0;
}

::v-deep .djsc_btn {
  display: none;
}
</style>
